import _ from 'lodash'

import { CAPABILITIES_TYPES } from '../constants'

export const getBacsCapability = (nursery) => (
  _.find(nursery?.stripeNurseryIntegration?.capabilities, ({ code }) => (
    CAPABILITIES_TYPES.BACS === code
  ))
)
